import GlossaryMarkdown from "~/widgets/GlossaryMarkdown/GlossaryMarkdown";
import styles from "~/pages/CharacterSheet/widgets/ProfileCard/ProfileCard.scss";
import React, { useState } from "react";

export interface ProfileCardProps {
  title: string;
  content: string;
  placeholder: string;
  editingPlaceholder: string;
  onChange: (content: string) => void;
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  title,
  content,
  placeholder,
  editingPlaceholder,
  onChange
}) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div className={styles.profileCard}>
      <div className={styles.profileCardHeader}>
        <span className={styles.profileCardTitle}>{title}</span>
        <button
          type="button"
          className={styles.editToggle}
          onClick={() => setIsEditing(!isEditing)}
          aria-label={isEditing ? `Finish editing: ${title}` : `Edit: ${title}`}
        >
          {isEditing ? "Done" : "Edit"}
        </button>
      </div>
      {isEditing ? (
        <>
          <textarea
            className={styles.profileTextarea}
            value={content}
            onChange={(e) => onChange(e.target.value)}
            placeholder={editingPlaceholder}
            autoFocus
            onKeyDown={(e) => {
              e.stopPropagation();
              if ((e.key === "Enter" && (e.metaKey || e.ctrlKey)) || e.key === "Escape") {
                e.preventDefault();
                setIsEditing(false);
              }
            }}
          />
          <div className={styles.editHint}>
            <strong>CMD/CTRL+Enter</strong> or <strong>ESC</strong> to save
          </div>
        </>
      ) : (
        <div
          className={styles.profileContent}
          onDoubleClick={() => setIsEditing(true)}
        >
          {content ? (
            <GlossaryMarkdown>{content}</GlossaryMarkdown>
          ) : (
            <span style={{ color: "var(--colorTextMuted)", fontStyle: "italic" }}>
              {placeholder}
            </span>
          )}
        </div>
      )}
    </div>
  )
}

export default ProfileCard;
